import React, { useRef, useState } from "react";

// Saisie du code de partie : une case par caractère, comme sur la maquette.
// Le champ réel reste au-dessus, invisible mais focalisable — il garde la
// frappe, le collage, l'autocomplétion et le clavier mobile. Les cases ne sont
// que la peinture.
export const CODE_LENGTH = 5;

function CodeInput({ value = "", onChange, onSubmit, autoFocus = false, length = CODE_LENGTH }) {
  const inputRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const chars = value.toUpperCase().slice(0, length).split("");
  // Case courante : la première vide, ou la dernière quand le code est complet
  const cursor = Math.min(chars.length, length - 1);

  return (
    <div class="pq-code-wrap" onClick={() => inputRef.current?.focus()}>
      <div class="pq-code" aria-hidden="true">
        {Array.from({ length }, (_, i) => {
          const char = chars[i];
          const active = focused && i === cursor;
          return (
            <span key={i} class={`pq-code-cell${char ? "" : " empty"}${active ? " active" : ""}`}>
              {char || "–"}
            </span>
          );
        })}
      </div>
      <input
        ref={inputRef}
        class="pq-code-field"
        type="text"
        inputMode="text"
        autoComplete="one-time-code"
        autoCapitalize="characters"
        autoCorrect="off"
        spellCheck="false"
        maxLength={length}
        autoFocus={autoFocus}
        value={value.toUpperCase()}
        aria-label="Code"
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={e => onChange(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, length))}
        onKeyDown={e => { if (e.key === "Enter" && onSubmit) onSubmit(); }}
        onPaste={e => {
          // Un lien de partie collé (…/partie/VDARS) ne laisse que son code :
          // sans ça, la limite de longueur garderait « HTTPS ».
          const text = e.clipboardData.getData("text").trim();
          const code = (text.match(/\/partie\/([A-Za-z0-9]+)/) || text.match(/([A-Za-z0-9]+)\W*$/) || [])[1];
          if (!code) return;
          e.preventDefault();
          onChange(code.toUpperCase().slice(0, length));
        }}
      />
    </div>
  );
}

export default CodeInput;
